import { Injectable } from "@angular/core";
import { AppConfig } from "../app.config";

@Injectable()
export class AppWideUser {
    UserName : string ;
    Password : string ;
    ConfirmPassword : string ;
    UserId : number ;
    FirstName : string ;
    LastName : string ;
    Email : string ;
    IsFirstTimeUser : boolean ;
    MobileNumber : string ;
    Roles : Array<string> ;
}

@Injectable()
export class Token {
    access_token: string;
    token_type: string;
    expires_in: string;
    userName: string;
    issued: string
    expires: string;
    webAPIURL: string = AppConfig.settings.apiServer.webAPIURL;
}




// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Services/AppUserProfile.ts